<template>
    <div class="user">
        <!--内容-->
        <div class="product-content">
            <div class="table-wrap">
                <el-select
                        placeholder="请选择考试任务"
                        style="width: 100%;"
                        v-model="value"
                        value-key="id"
                        @change="changeValue">
                    <el-option
                            v-for="item in tableData"
                            :key="item.id"
                            :label="item.plan_name"
                            :value="item">
                    </el-option>
                </el-select>
            </div>

            <div class="content">
                <el-card class="box-card" style="width: 100%;">
                    <div slot="header" class="clearfix">
                        <span>基本信息</span>
                    </div>
                    <div class="text item">
                        <div class="info">{{ detail.exam_time }}</div>
                        <div class="info">报考专业：{{ detail.career }}</div>
                        <div class="info">准考证号：{{ detail.admission_number }}</div>
                        <div class="info">证件号码：{{ detail.id_card }}</div>
                        <div class="info">姓名：{{ detail.name }}</div>
                    </div>

                    <div class="qualified">
                        <span class="blue fb" style="float: left; padding: 3px 0">总分：<span style="font-size: 24px">{{ sumCount() || 0 }}</span></span>
                        <span style="float: right; padding: 3px 0">考试成绩：
                            <span class="fb red" style="font-size: 24px" v-if="detail.qualified == 0">不及格</span>
					        <span class="fb green" style="font-size: 24px" v-if="detail.qualified == 1">及格</span>
                        </span>
                    </div>

                    <div class="clearfix">
                        <div class="grades">各科成绩</div>

                        <el-row>
                            <el-col :span="8">
                                <div class="grid-content bg-purple-dark">
                                    <div class="grid-text">{{ detail.theory }}</div>
                                    <div class="grid-title">理论</div>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="grid-content bg-purple-dark">
                                    <div class="grid-text">{{ detail.skill }}</div>
                                    <div class="grid-title">技能</div>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="grid-content bg-purple-dark">
                                    <div class="grid-text">{{ detail.comprehensive }}</div>
                                    <div class="grid-title">综合</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </div>

        </div>
    </div>
</template>

<script>
    import SignApi from '@/api/sign.js';
    import { getCookie } from '@/utils/base.js';

    export default {
        data() {
            return {
                id: '',
                // 是否加载完成
                loading: true,
                // 列表数据
                tableData: [],
                value: '',
                detail:{},
                sum: 0,
            };
        },
        created() {
            // 获取列表
            this.getTableList();
        },
        methods: {
            // 获取列表
            getTableList() {
                let that = this

                that.loading = true

                SignApi.getMyScoreList({
                    token: getCookie('token_supplier'),
                }, true)
                    .then(res => {
                        that.loading = false
                        that.tableData = res.data.list
                        that.value = res.data.list[0]
                        that.detail = res.data.list[0]
                    })
                    .catch(error => {

                    });
            },

            // 切换成绩
            changeValue(val){
                console.log(val)
                this.detail = val
            },

            // 计算总分
            sumCount(){
                return Number(this.detail.theory) + Number(this.detail.skill)
            }


        }
    };
</script>

<style lang="scss" scoped>
    .content{
        margin-top: 30px;
        .text {
            font-size: 14px;
        }
        .item {
            margin-bottom: 18px;
            .info{
                padding: 10px;
            }
        }
        .clearfix:before,
        .clearfix:after {
            display: table;
            content: "";
        }
        .clearfix:after {
            clear: both
        }
        .box-card {
            width: 480px;
        }

        .qualified{
            margin-bottom: 30px;
        }
        .grades{
            text-align: center;
            height: 50px;
            line-height: 50px;
            font-size: 18px;
            font-weight: bold;
        }

        .el-row {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .bg-purple-dark {
            background: #99a9bf;
        }
        .bg-purple {
            background: #d3dce6;
        }
        .bg-purple-light {
            background: #e5e9f2;
        }
        .grid-content {
            min-height: 36px;
            text-align: center;
            padding: 20px;
            border: 1px solid #eee;
            .grid-text{
                font-size: 24px;
                font-weight: bold;
            }
            .grid-title{
                font-size: 16px;
                font-weight: bold;
            }
        }
        .row-bg {
            padding: 10px 0;
            background-color: #f9fafc;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/score/index.vue